import * as signalR from "@microsoft/signalr";
import React, { useEffect, useRef, useState } from "react";
import styled, { createGlobalStyle } from "styled-components";
import Loading from "../based/Loading";
import connection from "./SignalR";
import GameServices from "./GameServices";
import Common from "../based/Common";
import AddressSystemHistoryModal from "./AddressSystemHistoryModal";
import QRModal from "./QRModal";

function AddressSystemPage(props) {
    const [listAddressInfo, setListAddressInfo] = useState();
    const [busy, setBusy] = useState(false);
    const timeoutRef = useRef(null);
    const intervalRef = useRef(null);
    const [listHistoryIP, setListHistoryIP] = useState([]);
    const [interfaceName, setInterfaceName] = useState("");
    const [qrString, setQrString] = useState("");

    console.log("listAddressInfo :>> ", listAddressInfo);

    useEffect(() => {
        if (!connection) return;

        //chưa connection thì connect
        if (connection.state === signalR.HubConnectionState.Disconnected) {
            connection
                .start()
                .then(() => {})
                .catch((err) => console.error(`AddressSystemPage: ${err}`));
        }
    }, []);

    useEffect(() => {
        if (!connection) return;

        //lấy thông tin ip history
        getListHistory();

        //nhận ds ip
        const receiveActiveIp = (tikIps) => {
            if (!tikIps) return;

            var lst = JSON.parse(tikIps);
            if (lst && lst.length > 0) {
                lst = lst.filter((x) => x.Name && x.Name.startsWith("VPN"));
            }
            setListAddressInfo(lst);

            setBusy(false);
            if (timeoutRef) clearTimeout(timeoutRef.current);
            if (intervalRef) clearInterval(intervalRef.current);
        };

        //nhận ip sau reset
        const receiveIpByInterface = (ipInfo) => {
            if (!ipInfo) return;

            const ip = JSON.parse(ipInfo);
            if (ip) {
                if (ip.IsSuccess) {
                    setListAddressInfo((prev) => {
                        const lst = [...prev];
                        var find = lst.find((x) => x.Name === ip.Name);
                        if (find != null) {
                            find.IP = ip.IP;
                            find.CreatedDate = new Date();
                        }
                        return lst;
                    });
                    getListHistory();
                }
            }
            setBusy(false);
        };

        const receivePeerStatus = (peerStatus) => {
            if (!peerStatus) return;
            var lstStatus = JSON.parse(peerStatus);
            if (lstStatus) {
                setListAddressInfo((prev) => {
                    if (prev == null) return prev;
                    var lst = [...prev];
                    lst.forEach((x) => {
                        var find = lstStatus.find((s) => s.Name === x.PeerName);
                        if (find) {
                            x.IsRunning = find.IsRunning;
                        } else {
                            x.IsRunning = false;
                        }
                    });
                    return lst;
                });
            }
        };

        connection.on("ReceiveActiveIP", receiveActiveIp);
        connection.on("ReceiveIpByInterface", receiveIpByInterface);
        connection.on("ReceivePeerStatus", receivePeerStatus);

        return () => {
            connection.off("ReceiveActiveIP", receiveActiveIp);
            connection.off("ReceiveIpByInterface", receiveIpByInterface);
            connection.off("ReceivePeerStatus", receivePeerStatus);
        };
    }, []);

    //invoke khi connected
    useEffect(() => {
        if (connection.state !== signalR.HubConnectionState.Connected) return;

        //handler nhận message
        setBusy(true);

        timeoutRef.current = setTimeout(() => {
            setBusy(false);
        }, 20000);

        connection.invoke("GetActiveIp");

        return () => clearTimeout(timeoutRef.current);
    }, [connection.state]);

    const resetIpByInterface = (interfaceName) => {
        if (!interfaceName) return;

        setBusy(true);

        timeoutRef.current = setTimeout(() => {
            setBusy(false);
        }, 20000);

        connection.invoke("ResetIpByInterface", interfaceName);
    };

    const getListHistory = async () => {
        const [err, data] = await GameServices.GetListHistoryIP();
        if (!err && data) {
            setListHistoryIP(data);
        } else {
            setListHistoryIP([]);
        }
    };

    return (
        <React.Fragment>
            <GlobalStyle />
            <Loading show={busy} msg="Đang gọi Mikrotik lấy dữ liệu..." />
            <Wrapper>
                <table className="table table-bordered">
                    <thead>
                        <tr
                            style={{
                                height: "50px",
                            }}
                        >
                            <th className="center">STT</th>
                            <th className="center">Flags</th>
                            <th className="center">IP</th>
                            <th className="center">Interface</th>
                            <th className="center">Created Date</th>
                            <th className="center">Current IP</th>
                            <th className="center">
                                <div className="d-flex flex-column">
                                    Active Host Name
                                    <sub>
                                        <span>Tên thiết bị trong local (wifi)</span>
                                    </sub>
                                </div>
                            </th>
                            <th className="center">
                                <div className="d-flex flex-column">
                                    Is Running
                                    <sub>
                                        <span>Rx/Tx thay đổi trong 5s</span>
                                    </sub>
                                </div>
                            </th>
                            <th className="center"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {listAddressInfo && listAddressInfo.length > 0 ? (
                            listAddressInfo.map((x, index) => {
                                return (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{x.Flags}</td>
                                        <td>{x.IP}</td>
                                        <td>{x.Name}</td>
                                        <td>{Common.formatDate(new Date(x.CreatedDate), "fulldate")}</td>
                                        <td>{x.CurrentEndpointAddress}</td>
                                        <td>{x.ActiveHostName}</td>
                                        <td>{x.IsRunning ? <span className="badge badge-success">Đang chạy</span> : <span className="badge badge-danger">Không chạy</span>}</td>
                                        <td>
                                            <span
                                                className="badge badge-primary m-1 cursor-pointer"
                                                onClick={(e) => {
                                                    resetIpByInterface(x.Name);
                                                }}
                                            >
                                                Reset IP
                                            </span>
                                            <span
                                                className="badge badge-primary m-1 cursor-pointer"
                                                onClick={(e) => {
                                                    setInterfaceName(x.Name);
                                                }}
                                            >
                                                Lịch sử
                                            </span>
                                            {x.QrString != "" && (
                                                <span
                                                    className="badge badge-primary m-1 cursor-pointer"
                                                    onClick={(e) => {
                                                        setQrString(x.QrString);
                                                    }}
                                                >
                                                    Xem Qr
                                                </span>
                                            )}
                                        </td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan={1000} className="center">
                                    Không có dữ liệu
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>

                <div className="game_item-bottom">
                    {listHistoryIP && listHistoryIP.length > 0 ? (
                        <div className={`lst_delta-gas`}>
                            {listHistoryIP.map((dm, di) => {
                                let ip = dm.ip;
                                let splitIp = ip.split("/");
                                let ipAddress = splitIp.length > 0 ? splitIp[0] : ip;
                                return (
                                    <React.Fragment key={di}>
                                        <span className={`badge m-1 ${dm.count > 1 ? "badge-danger" : "badge-success"}`}>
                                            {ipAddress} ({dm.name})
                                        </span>
                                    </React.Fragment>
                                );
                            })}
                        </div>
                    ) : null}
                </div>
            </Wrapper>
            <AddressSystemHistoryModal
                show={interfaceName != ""}
                interfaceName={interfaceName}
                onClose={() => {
                    setInterfaceName("");
                }}
            />
            <QRModal
                show={qrString != ""}
                qrString={qrString}
                onClose={() => {
                    setQrString("");
                }}
            />
        </React.Fragment>
    );
}

export default AddressSystemPage;

const GlobalStyle = createGlobalStyle`
body.enlarged {
    height: 100vh!important;
    min-height: 100vh!important;
}
div#root {
    height: 100%;
}
.content-page {
        height: 100%;
        overflow: auto;
    }
`;
const Wrapper = styled.div``;
